import { storageService } from "@/modules/common/services";
import { authService } from "../services/authService";

const state = {
  staffUid: null,
  token: null
};

const getters = {
  staffUid: state => state.staffUid,
  token: state => state.token,
  isAuthenticated: state => !!state.token
};

const mutations = {
  setStaffUid(state, staffUid) {
    state.staffUid = staffUid;
  },
  saveToken(state, jwt) {
    storageService.save(`login_jwt_${state.staffUid}`, jwt);
    state.token = jwt;
  },
  setToken: (state, token) => {
    state.token = token;
  }
};

const actions = {
  init: ({ commit, dispatch }, staffUid) => {
    commit("setStaffUid", staffUid);
    const token = storageService.get(`login_jwt_${staffUid}`);
    commit("setToken", token);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
